import { CmsApiBlock } from 'modules/cms/api/types/CmsApiBlock';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { cmsBlockMappingByType } from 'modules/cms/blocks/cmsBlockMappingByType';

type Props = {
  content: CmsApiPage;
  block: CmsApiBlock;
  blockIndex: number;
};

export function CmsAmpContentBlock({ content, block, blockIndex }: Props) {
  if (!cmsBlockMappingByType[block.type]) {
    return null;
  }

  const { AmpComponent } = cmsBlockMappingByType[block.type];
  if (!AmpComponent) return null;

  return (
    <AmpComponent
      content={content}
      blockId={block.id}
      blockIndex={blockIndex}
      data={block.data}
      context="amp"
      pageUpdated={content.updated}
    />
  );
}
